import React, {ReactElement} from 'react';

const styles = require('./index.module.less');

const Footer: React.FC = (): ReactElement => {
  return (
    <div className={styles.container}>
      <a href={'https://jx3.seasunwbl.com/protocol'} target={'_blank'}>万宝楼交易平台服务协议</a>
      <a href={'https://beian.miit.gov.cn/'} target={'_blank'}>琼ICP备2021004338号-3</a>
      <a href={'https://jx3.seasunwbl.com/license/'} target={'_blank'}>增值电信业务经营许可证</a>
      <div>Copyright © 2012-{new Date().getFullYear()} 海南西山居互动娱乐科技有限公司</div>
    </div>
  )
}
export default Footer;